import { forwardRef, memo, useCallback, type ChangeEvent } from 'react';
import { FormattedMessage } from 'react-intl';
// Material UI imports
import type { SxProps, Theme } from '@mui/material';
import Box from '@mui/material/Box';
import FormControlLabel, { type FormControlLabelProps } from '@mui/material/FormControlLabel';
import Switch, { type SwitchProps } from '@mui/material/Switch';

const opacitySx: SxProps<Theme> = { opacity: 0.618 } as const;

type OnOffSwitchProps = {
  readonly label?: string;
  readonly italic?: boolean;
  readonly disabled?: boolean;
  readonly value: boolean;
  readonly onChange: (value: boolean) => void;
  readonly sx?: FormControlLabelProps['sx'] & SwitchProps['sx'];
};

const OnOffSwitch = forwardRef<HTMLButtonElement, OnOffSwitchProps>(({
  label,
  italic = false,
  disabled = false,
  value,
  onChange,
  sx
}, ref) => {

  const handleChange = useCallback((event: ChangeEvent<HTMLInputElement>) => {
    onChange(Boolean(event.target.checked));
  }, [onChange]);

  return label ? (
    <FormControlLabel
        ref={ref}
        sx={sx}
        label={(
          <Box
              pl={1}
              fontStyle={italic ? 'italic' : undefined}
              color={italic ? 'info.caption' : undefined}
              sx={italic && disabled ? opacitySx : undefined}
          >
            <FormattedMessage id={label} defaultMessage={label}/>
          </Box>
        )}
        disabled={disabled}
        control={(
          <Switch
              // color={color}
              color="default"
              checked={value}
              onChange={handleChange}
          />
        )}
    />
  ) : (
    <Switch
        ref={ref}
        sx={sx}
        // color={color}
        color="secondary"
        checked={value}
        disabled={disabled}
        onChange={handleChange}
    />
  );
});

OnOffSwitch.displayName = 'OnOffSwitch';

export default memo(OnOffSwitch);
